export class AddText {
  public static readonly type = '[Text] Add';
  constructor(public text?: string) {}
}
